import { type MutableRefObject, useRef } from 'react';

/*
 * Хук для создания мутабельного объекта который будет хранить в себе актуальные значения,
 * но не влиять на зависимости в useCallback/useMemo
 * @kind helper
 */
export function useMutableObject<T>(obj: T): MutableRefObject<T> {
    const refCache = useRef(obj);

    // eslint-disable-next-line react-hooks/refs -- Автоматический игнор в рамках DIRECT-288723
    refCache.current = obj;

    return refCache;
}
